import styled from 'styled-components';
import CTA from '../../components/cta';
import { breakpoint } from '../../components/theme/breakpoint';
import { Banner } from '../../components/donation-banner/styles';
import RichText from '../../components/rich-text';
import { multiplyPx } from '../../components/styled/utils';

const doublePx = multiplyPx(2);

const buttonWidth = '168px';

const cookieSmall = '150px';
const cookieMobile = '125px';
const cookieTablet = '100px';
const cookieDesktop = '75px';

export const AssemblyWrapper = styled.div`
  overflow: hidden;

  ${Banner} {
    // border top on donation banner always required on splash page
    border-top: ${({ theme }) => `1px solid ${theme.palette.border}`};

    // bottom padding and margin to accomodate sticky cookie banner area
    margin-bottom: ${({ theme }) => theme.spacing.xlarge};
    padding-bottom: ${cookieSmall};

    ${breakpoint.mobile`
      padding-bottom: ${cookieMobile};
    `}

    ${breakpoint.tablet`
      padding-bottom: ${cookieTablet};
    `}

    ${breakpoint.desktop`
      padding-bottom: ${cookieDesktop};
    `}
  }
`;

export const LogoWrapper = styled.div`
  padding: ${({ theme }) => `${theme.spacing.xlarge} 0`};
  margin: 0 auto;
  max-width: 220px;

  ${breakpoint.tablet`
    padding-top: ${({ theme }) => theme.spacing.xlarge};
    max-width: 300px;
  `}

  ${breakpoint.desktop`
    padding-top: ${({ theme }) => doublePx(theme.spacing.xlarge)};
  `}
`;

export const Logo = styled.img`
  display: flex;
  margin: 0 auto;
  width: 128px;

  ${breakpoint.desktop`
    width: 160px;
  `}
`;

export const CTAWrapper = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  max-width: ${buttonWidth};

  ${breakpoint.desktop`
    margin: ${({ theme }) => theme.spacing.large} auto ${({ theme }) =>
    theme.spacing.standard} auto;
    grid-template-columns: 1fr 1fr;
    max-width: calc(
      ${buttonWidth} * 2 + ${({ theme }) => theme.spacing.standard}
    );
    `}
`;

export const StyledCTA = styled(CTA)`
  width: ${buttonWidth};
  margin-right: 0;
  margin-bottom: ${({ theme }) => theme.spacing.standard};

  ${breakpoint.tablet`
    &:nth-of-type(1),
    &:nth-of-type(2) {
      margin-bottom: ${({ theme }) => theme.spacing.standard};
    }

    &:nth-of-type(1),
    &:nth-of-type(3) {
      margin-right: ${({ theme }) => theme.spacing.standard};
    }
  `}
`;

export const StyledRichText = styled(RichText)``;

export const StyledArticle = styled.article`
  text-align: center;

  ${StyledRichText} {
    &:nth-of-type(1) {
      margin-bottom: ${({ theme }) => theme.spacing.medium};
    }
  }

  ${StyledRichText} {
    &:nth-of-type(3) {
      margin-bottom: ${({ theme }) => theme.spacing.xlarge};
    }
  }
`;
